/**
 * maxLeverage가 낮아졌을 때 오더폼 chip leverage를 어떻게 조정할지 결정하는 순수 로직.
 *
 * - 포지션(또는 pending)이 있으면 그 leverage를 그대로 보여준다 → 조정 안 함(undefined).
 * - 포지션이 없으면 min(현재 selected, max) → 현재값이 max를 넘을 때만 max로 낮춘다.
 *
 * `maxLeverage`는 호출 측에서 mode-aware ceiling(`modeMax`)을 넘긴다.
 *
 * @returns 새로 설정할 leverage. 변경이 필요 없으면 undefined.
 */
export const clampFormLeverageOnMaxChange = (params: {
  /** one-way 포지션/pending의 leverage (있으면 chip은 그 값을 유지) */
  positionLeverage: number | undefined | null;
  /** 현재 chip(폼)에 선택된 leverage */
  currentLeverage: number;
  /** Mode-aware ceiling (Isolated → effectiveIsolatedMax, Cross → crossMax) */
  maxLeverage: number | undefined | null;
}): number | undefined => {
  const { positionLeverage, currentLeverage, maxLeverage } = params;

  // 포지션이 있으면 해당 포지션 leverage를 그대로 보여준다 (상한 clamp 안 함).
  if (positionLeverage != null) return undefined;

  if (maxLeverage == null || currentLeverage <= maxLeverage) return undefined;

  return maxLeverage;
};
